import React, { useState } from 'react';
import MultipleCountrySelect from '@/pages/intelligence/components/ComposedCountrySelect/components/MultipleCountrySelect';
import { analysisRegionsCountriesData } from '@/pages/intelligence/components/ComposedCountrySelect/utils';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getShowLabel } from '../../utils';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { IMultipleSelectorProp } from '../../type';

export default function RegionSelector(props: IMultipleSelectorProp) {
  // console.log(props);
  const { value: formItemValue, field, onChange, formItem } = props;
  const { value = [], options = [] } = formItemValue || {};
  const [ searchKeywords, setSearchKeywords ] = useState('');
  const { formatMessage, locale } = useIntlExtend();

  const { groups, options: countryOptions } = analysisRegionsCountriesData(options, locale);

  const renderOptionName = (name: string) => {
    if (!searchKeywords?.trim()?.length) return name;
    // 单选、并且 当前option就是选中项时，不高亮
    const searchKeywordsChars = searchKeywords?.split('')?.filter((item) => item);
    const reg = new RegExp(searchKeywordsChars?.join('|'), 'ig');
    return name?.replace(reg, (item) => `<span class="dbi-country-highlight">${item}</span>`);
  };

  return(
    <div className={'search-item dbi-composed-country-select'}>
      <MultipleCountrySelect
        isAll={false}
        style={{ width: 282 }}
        className="dbi-composed-country-select_country-select dbi-composed-country-select_multiple-country-select"
        groups={groups}
        renderOptionName={renderOptionName}
        options={countryOptions}
        value={value}
        // value={formModel?.[field]}
        onConfirm={(payload: string[]) => {
          onChange(field, {
            value: payload,
            options,
          });
        }}
        onSearch={(payload?: string) => {
          const keywordsTmp = payload ?? '';
          setSearchKeywords(keywordsTmp);
        }}
        onClose={() => {
          setSearchKeywords('');
        }}
      />
      {getShowLabel(formItem, formatMessage, 'msg') && <TipContext AWidth={381} tipText={getShowLabel(formItem, formatMessage, 'msg')} className="dbi-tip-icon" />}
    </div>
  )
}
